"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOffDaysStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../../common/i18n"));
exports.useOffDaysStore = (0, pinia_1.defineStore)("offDaysStore", {
    state: () => ({
        offDays: [],
    }),
    getters: {},
    actions: {
        getOffDays(locationId) {
            this.offDays = [];
            if (locationId === undefined) {
                return;
            }
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/get/offdays", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ locationId: locationId }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        reject(i18n_1.default.trans("backend_off_day_error", "No OffDay found!", "backend"));
                        return;
                    }
                    this.offDays = [];
                    const offDaysArray = Object.values(response);
                    offDaysArray.forEach((item) => {
                        this.offDays.push(item);
                    });
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        deleteDate(id) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/delete/offday/" + id, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        reject(i18n_1.default.trans("backend_off_day_delete_error", "Something went wrong when deleting the off day!", "backend"));
                        return;
                    }
                    if (typeof response.success !== "undefined" &&
                        response.success === true) {
                        if (this.offDays) {
                            const offDayIndexIndex = this.offDays.findIndex((item) => item.id === id);
                            this.offDays.splice(offDayIndexIndex, 1);
                        }
                        return { success: true };
                    }
                    else {
                        return {
                            success: false,
                            error: i18n_1.default.trans("backend_off_day_delete_error", "Something went wrong when deleting the off day!", "backend"),
                        };
                    }
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        async addExcludedDaysInterval(fromDate, toDate, locationId) {
            try {
                const response = await (0, fetch_1.default)("/api/add/offday", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ fromDate, toDate, locationId }),
                });
                if (response.error) {
                    return {
                        success: false,
                        error: i18n_1.default.trans("backend_off_day_add_error", "Something went wrong when adding the off days!", "backend"),
                    };
                }
                if (response.success) {
                    this.getOffDays(locationId);
                    return { success: true };
                }
                else {
                    return {
                        success: false,
                        error: i18n_1.default.trans("backend_off_day_add_error", "Something went wrong when adding the off days!", "backend"),
                    };
                }
            }
            catch (error) {
                return {
                    success: false,
                    error: i18n_1.default.trans("backend_off_day_add_error", error.message ||
                        "Something went wrong with the request!", "backend"),
                };
            }
        },
    },
});
